import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const AuthLayout = () => {
  // AUTH pages use the Dostination SIGNATURE gradient: near-black base with
  // a warm rust/ember radial glow anchored at the right edge.
  // See /app/memory/design_language.md §1.1. Do NOT replace with navy blue.
  return (
    <div
      data-testid="auth-layout"
      className="dost-signature-bg-full flex items-center justify-center p-4"
    >
      <div className="w-full max-w-md">
        {/* Logo */}
        <Link to="/" className="flex items-center justify-center space-x-2 mb-8">
          <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center overflow-hidden">
            <img src="/logo-192.png" alt="Dostination" className="w-11 h-11 object-contain" />
          </div>
          <span className="font-display text-3xl font-bold text-white">
            Dostination
          </span>
        </Link>
        
        {/* Auth Form Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <Outlet />
        </div>
        
        {/* Footer */}
        <div className="text-center mt-6 text-white text-sm">
          <p className="mb-2">Premium gatherings and travel for intentional connections</p>
          <div className="flex items-center justify-center space-x-4">
            <Link to="/about" className="hover:underline">About</Link>
            <span>·</span>
            <Link to="/privacy" className="hover:underline">Privacy</Link>
            <span>·</span>
            <Link to="/terms" className="hover:underline">Terms</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
